const smoothScrollToAnchor = () => {
  // 1. Select all internal anchor links
  const internalLinks = document.querySelectorAll('a[href^="#"]');

  // 2. Define your sticky header offset
  const headerOffset = 130; // in pixels

  internalLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      // Get the target ID from the href attribute
      const targetId = this.getAttribute('href');

      // Check for a valid target ID to avoid errors
      if (targetId === "#") return;

      // Find the target element on the page
      const targetElement = document.querySelector(targetId);

      // 3. If the target element exists...
      if (targetElement) {
        // Prevent the default jump
        e.preventDefault();

        // 4. Calculate the correct scroll position
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;

        // 5. Scroll to the new position
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
};

// Run the function after the document is fully interactive or loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', smoothScrollToAnchor);
} else {
  smoothScrollToAnchor();
}